module.exports = __webpack_public_path__ + "static/media/main_sqr(1).e314e64f.jpg";